import dayjs from 'dayjs';

import sdk from '@/sdk';

import {ISummaryData, LikeStatus} from './interface';

const cache = new Map<string, ISummaryData>();

function getKey(docGuid: string, editionId: string) {
    return `${docGuid}:${editionId}`;
}

export const reset = () => {
    cache.clear();
};

export const updateCache = (summaryData: ISummaryData, editionId: string) => {
    const {docGuid} = summaryData;
    cache.set(getKey(docGuid, editionId), summaryData);
};

/**
 * 处理高亮后的字符串
 * @param str 原始字符串
 * @param highLightWordList 高亮关键词数组
 */
function replaceAfterHighLight(str: string, highLightWordList: string[]) {
    let result = str;
    const usedList: string[] = []; // 记录高亮过的关键词，避免重复高亮

    highLightWordList.forEach((word: string) => {
        if (usedList.some(item => item.includes(word) || word.includes(item))) { // 关键词有重叠
            const index = result.lastIndexOf('**');
            if (index > -1) {
                const substringBefore = result.substring(0, index + 2);
                let substringAfter = result.substring(index + 2);
                substringAfter = substringAfter.replace(word, `**${word}**`);

                result = substringBefore + substringAfter;
                usedList.push(word);
            }
        } else {
            result = result.replace(word, `**${word}**`);
            usedList.push(word);
        }
    });
    result = result.replaceAll('****', ''); // 边界场景处理

    return result;
}


export const getLikeStatus = async (summaryId: string) => {
    const ksServer = await sdk.getKsServer();
    return ksServer.getSummaryLikeStatus(summaryId);
};

export const setLikeStatus = async (summaryData: ISummaryData, editionId: string) => {
    const {likeStatus, summaryId, docGuid} = summaryData;

    const ksServer = await sdk.getKsServer();
    return ksServer.updateSummaryLikeStatus(likeStatus, summaryId, docGuid).then(() => {
        updateCache(summaryData, editionId);
    });
};

export const getSummaryData = async (docGuid: string, editionId: string) => {
    const cacheKey = getKey(docGuid, editionId);
    if (cache.has(cacheKey)) {
        return {
            ...cache.get(cacheKey) as ISummaryData,
            isCache: true,
        };
    }
    const ksServer = await sdk.getKsServer();
    const result = await ksServer.getDocSummary(docGuid, editionId);

    let likeStatus: LikeStatus | '' = '';
    if (result.summaryId) {
        try {
            const {type} = await getLikeStatus(result.summaryId);
            likeStatus = type;
        } catch (err) {
            console.error(err);
        }
    }

    if (!result?.summary && !result?.img) { // 摘要和截图信息均为空时，判断为加载失败，并且不缓存
        throw new Error('摘要和截图信息均为空');
    }

    // 摘要存在高亮块
    const highLightWords = result?.summaryPattern?.bold;
    const isHighLight = Array.isArray(highLightWords) && !!highLightWords.length;
    if (isHighLight && result.summary) {
        result.summary = replaceAfterHighLight(result.summary, highLightWords);
    }

    const summaryData: ISummaryData = {
        summaryId: result.summaryId,
        canSummary: result.canSummary === 1 && result.summary,
        summary: result.summary,
        img: result.img,
        publishTime: dayjs(result.publishTime).format('YYYY.MM.DD HH:mm'),
        creator: result.nickname,
        docGuid: result.docGuid,
        likeStatus,
        isHighLight,
    };
    cache.set(cacheKey, summaryData);

    return summaryData;
};
